import { ClassesByCourseRequest } from "./../models/course/classes-course-request"
import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { AppService } from "../../../core/services/app.service"
import {
  CustomURLEncoder,
  toHttpParams,
} from "src/app/core/helpers/http-params-extensions"
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"
import { CoursePaginateRequest } from "../models/course/course-paginate-request"
import { CourseCreateUpdateRequest } from "../models/course/course-create-update-request"
import { CourseForClassResponse } from "../models/class/course-for-class-response"
import { Observable } from "rxjs"
import { ClassInsertStudentOnCourse } from "../models/class/class-insert-student-on-course"
import { TurnoverCourseOption, TurnoverCourseOptionsRequest } from "../models/course/turnover-course-option"
import { DownloadContent } from 'src/app/shared/interfaces/download-content';
import { HEADERS } from './const/http-header-interception';

@Injectable({
  providedIn: "root",
})
export class CourseService {

  private get_course_paginate_url: string;
  private get_course_id_url: string;
  private get_user_in_course: string;
  private put_course_url: string;
  private post_course_url: string;
  private post_group_import_url: string;
  private get_courseOptions_url: string;
  private get_courseOptions_by_school_and_year_url: string;
  private get_informationsforClass_url: string;
  private get_course_turnover_options_url: string;
  private post_student_on_course: string;
  private post_finish_enrollment: string;
  private get_class_of_course_url: string;
  private post_join_students_url: string;
  private post_student_in_course_by_classes: string;
  private get_export_user_course: string
  private get_groups_by_classes_segment: string
  private get_courses_by_school_segment: string

  private buildUrls(courseUrl: string) {

    this.get_course_paginate_url = courseUrl + environment.endpointCourse.routes.get_course_paginate;
    this.get_course_id_url = courseUrl + environment.endpointCourse.routes.get_course_id;
    this.get_user_in_course = courseUrl + environment.endpointCourse.routes.get_user_course;
    this.put_course_url = courseUrl + environment.endpointCourse.routes.put_course;
    this.post_course_url = courseUrl + environment.endpointCourse.routes.post_course;
    this.post_group_import_url = courseUrl + environment.endpointCourse.routes.post_group_import;
    this.get_courseOptions_url = courseUrl + environment.endpointCourse.routes.get_course_options;
    this.get_courseOptions_by_school_and_year_url = courseUrl + environment.endpointCourse.routes.get_course_options_by_school_id_and_year;
    this.get_informationsforClass_url = courseUrl + environment.endpointCourse.routes.get_informations_for_class_url;
    this.get_course_turnover_options_url = courseUrl + environment.endpointCourse.routes.get_course_turnover_options;
    this.post_student_on_course = courseUrl + environment.endpointCourse.routes.post_student_on_course;
    this.post_finish_enrollment = courseUrl + environment.endpointCourse.routes.post_finish_enrollment;
    this.get_class_of_course_url = courseUrl + environment.endpointCourse.routes.get_class_of_course;
    this.post_join_students_url = courseUrl + environment.endpointCourse.routes.post_join_students;
    this.post_student_in_course_by_classes = courseUrl + environment.endpointCourse.routes.post_student_in_course_by_classes;
    this.get_export_user_course = courseUrl + environment.endpointCourse.routes.get_export_user_course
    this.get_groups_by_classes_segment = environment.endpointClass.url + environment.endpointClass.routes.get_groups_by_classes_segment
    this.get_courses_by_school_segment = environment.endpointClassesForm.url + environment.endpointClassesForm.routes.get_courses

  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointCourse.url)
  }

  getPaginate(coursePaginateRequest: CoursePaginateRequest) {
    const { ...others } = coursePaginateRequest
    let params = toHttpParams(others)
    // for (let i = 0, j = (grades ? grades.length : 0); i < j; ++i) {
    //   params = params.append(`grades[${i}]`, grades[i]);
    // }
    return this.httpClient.get(this.get_course_paginate_url, { params, headers: new HttpHeaders(HEADERS) })
  }

  postFile() {
    return this.post_group_import_url
  }

  getUserInCourse(param) {
    const p = { ...param }
    let params = toHttpParams(p)
    // for (let i = 0, j = (grades ? grades.length : 0); i < j; ++i) {
    //   params = params.append(`grades[${i}]`, grades[i]);
    // }
    return this.httpClient.get(this.get_user_in_course, { params, headers: new HttpHeaders(HEADERS) })
  }

  post(model: CourseCreateUpdateRequest) {
    return this.httpClient.post(this.post_course_url, model, { headers: new HttpHeaders(HEADERS) })
  }

  getClassOfCourse(paramClasses: ClassesByCourseRequest) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })

    params = params.set("courseId", paramClasses.courseId)
    params = params.set("status", paramClasses.status)

    return this.httpClient.get(this.get_class_of_course_url, { params, headers: new HttpHeaders(HEADERS) })
  }

  getOneCourse(courseId: string) {
    return this.httpClient.get(
      this.get_course_id_url.replace("{courseId}", courseId), { headers: new HttpHeaders(HEADERS) })
  }

  put(model: CourseCreateUpdateRequest) {
    return this.httpClient.put(
      this.put_course_url.replace("{courseId}", model.id), model, { headers: new HttpHeaders(HEADERS) })
  }
  getCourseOptions() {
    return this.httpClient.get(this.get_courseOptions_url, { headers: new HttpHeaders(HEADERS) })
  }

  getCourseOptionsBySchoolIdAndYear(schoolId: string, year: string) {
    return this.httpClient.get(this.get_courseOptions_by_school_and_year_url.replace("{schoolId}", schoolId).replace("{ano}", year), { headers: new HttpHeaders(HEADERS) })
  }

  getDataByCourse(courseId: string): Observable<CourseForClassResponse> {
    return this.httpClient.get<CourseForClassResponse>(
      this.get_informationsforClass_url.replace("{courseId}", courseId), { headers: new HttpHeaders(HEADERS) })
  }

  getTurnoverOptions(filters: TurnoverCourseOptionsRequest): Observable<TurnoverCourseOption[]> {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    params = params.set("schoolId", filters.schoolId)
    params = params.set("schoolYear", filters.schoolYear)
    params = params.set("segmentId", filters.segmentId)
    params = params.set("gradeId", filters.gradeId)
    if (filters.referenceTurnId) {
      params = params.set("referenceTurnId", filters.referenceTurnId)
    }

    return this.httpClient.get<TurnoverCourseOption[]>(
      this.get_course_turnover_options_url, { params, headers: new HttpHeaders(HEADERS) })
  }

  postStudentOnCourse(model: ClassInsertStudentOnCourse) {
    return this.httpClient.post(
      this.post_student_on_course.replace("{courseId}", model.courseId), model.studentsId, { headers: new HttpHeaders(HEADERS) })
  }

  postFinishEnrollment(courseId: string, listStudents: any[]) {
    return this.httpClient.post(
      this.post_finish_enrollment.replace("{courseId}", courseId), listStudents, { headers: new HttpHeaders(HEADERS) })
  }

  joinStudentsInClass(classId: string, listStudents: any[]) {
    return this.httpClient.post(
      this.post_join_students_url.replace("{classId}", classId), listStudents, { headers: new HttpHeaders(HEADERS) })
  }

  postStudentInCourseByClasses(studentId: string, listClasses: any[]) {
    return this.httpClient.post(
      this.post_student_in_course_by_classes.replace("{studentId}", studentId), listClasses, { headers: new HttpHeaders(HEADERS) })
  }

  getExportUserCourse(date: number): Observable<DownloadContent> {
    return this.httpClient.get<DownloadContent>(`${this.get_export_user_course}/${date}`, { headers: new HttpHeaders(HEADERS) })
  }

  getGroupsByClassesAndSegment(courseId: string, segmentId: string) {
    return this.httpClient.get(`${this.get_groups_by_classes_segment.replace("{courseId}", courseId).replace("{segmentId}", segmentId)}`, { headers: new HttpHeaders(HEADERS) })
  }

  getProductsStatus(profiles: Array<{ id: string }>, customParams: Array<{ name: string, value: string }>) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    const headers = new HttpHeaders(HEADERS);
    if (customParams) customParams.forEach(param => params = params.set(param.name, param.value))
    const url = `${environment.endpointClassesForm.url}/v1/product/profile`;
    return this.httpClient.post(url, { profiles: profiles }, { params, headers });
  }

  getCoursesBySchoolIdAndSegmentId(schoolId: string, customParams?: Array<{ name: string, value: string }>) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (customParams) customParams.forEach(param => params = params.set(param.name, param.value))
    return this.httpClient.get(this.get_courses_by_school_segment.replace("{schoolId}", schoolId), { params, headers: new HttpHeaders(HEADERS) })
  }

}
